module.exports = __webpack_public_path__ + "img/map_icon_dark.52725902.svg";